// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__+ihpa","footerTop":"Footer_footerTop__hR6Ft","footerLinkLeft":"Footer_footerLinkLeft__OqtBs","footerBottom":"Footer_footerBottom__qjjsX"};